// ref: https://github.com/gothinkster/vue-realworld-example-app

import Vue from 'vue';
import Vuex from 'vuex';
import { INITIALIZE } from './actions.type';

import search from './search.module';
import user from './user.module';
import todos from './todos.module';

Vue.use(Vuex);

export const actions = {
    [INITIALIZE]({ state }) {
        const urlParams = new URLSearchParams(window.location.search);
        state.search.text = urlParams.get('q');
        state.search.entityId = urlParams.get('entity');
        return state;
    },
};

export default new Vuex.Store({
    modules: {
        search,
        user,
        todos,
    },
    // state: {},
    // mutations: {},
    actions,
    // modules: {},
});
